Alpine.data('alpine_hero_carousel', () => ({
  swiper: null,
  initSwiper() {
    this.swiper = new Swiper(this.$refs.container, {
      autoplay: {
        delay: 6000,
      },
      keyboard: true,
      // lazy: {
      //   loadOnTransitionStart: true
      // },
      loop: true,
      navigation: {
        nextEl: '.button-next-home',
        prevEl: '.button-prev-home'
      },
      observer: true,
      observeParents: true,
      pagination: {
        el: '.swiper-pagination-x',
        clickable: true
      },
      preloadImages: false,
      slidesPerView: 1,
      swipeHandler: '.swiper-wrapper',
    });
  },

  init() {
    this.initSwiper();
  },
}));
